<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FvglaG/tc-custom/9781488021619.jpg?1695285217977" alt="This image is the cover for the book Knight's Scarred Maiden, Lovers and Legends"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Knight's Scarred Maiden, Lovers and Legends
      </h1>
      <p class="bookDescription body article font2">
        <b>“A beautifully written tale of loss, faith and the magic of love between a scarred maiden and the deadly mercenary she rescues. Well done!” (<i>RT Book Reviews</i>).</b><br/><br/>As a mercenary knight, Rhain has always lived on borrowed time. Now, with a vengeful warlord pursuing him, he has come to accept his fate. But however he may meet his end, he is determined to get his men to safety. <br/><br/>When he rescues mysterious and deeply scarred Helissent from her attackers, Rhain soon wishes he wasn’t marked for death. He can never be the man she deserves—his scandalous lineage alone dictates that—but Rhain can’t resist the temptation to show this innocent maiden how beautiful she truly is . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicole Locke
      </h2>
      
      <p class="authorDescription body article">Nicole&#160;first discovered romance novels hidden in her grandmother&#39;s closet. Convinced hidden books must be better, Nicole greedily read them. It was only natural she should start writing them (but now not so secretly).<Br><Br>If she isn&#39;t working on the next book in her historical series, she can be reached at NicoleLocke.com or on twitter @NicoleLockeNews!&#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ee9fcaa